import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import { TitleContext } from "../../../Context/TitleContext";
import { API_URL, useAxios } from "../../../utils/const";
import { Toaster } from "react-hot-toast";

const CourseLecturers = () => {
  const { setTitle } = useContext(TitleContext);
  const axiosInstance = useAxios();

  const [courses, setCourses] = useState({ courses: [], totalRecords: 0 });
  const [courseRecords, setCourseRecords] = useState([]);

  useEffect(() => {
    setTitle("USAKTI | Reg. Modul Dosen"); // Set judul halaman
  }, [setTitle]);

  useEffect(() => {
    getCourses();
  }, []);

  const getCourses = async () => {
    const response = await axiosInstance.get(`${API_URL}/courses`);
    setCourses({
      courses: response.data.data,
      totalRecords: response.data.totalRecords,
    });
    setCourseRecords(response.data.data);
  };

  return (
    <div>
      <Toaster position="top-right" />
      <div className="container-fluid">
        <div className="card mb-4">
          <div className="card-body">
            <h1>Registrasi Modul Dosen</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active">Registrasi Modul Dosen</li>
            </ol>
          </div>
        </div>

        <div className="card">
          <div className="card-body m-3">
            <div className="row mt-3">
              <div className="col-md-4 text-center offset-md-4">
                <h4>Daftar Modul</h4>
              </div>
            </div>

            <Accordion className="mt-3">
              {courseRecords.map((item, index) => (
                <Accordion.Item eventKey={index.toString()} key={index}>
                  <Accordion.Header>Semester {item.name}</Accordion.Header>
                  <Accordion.Body>
                    <div className="table-responsive">
                      <table className="table table-striped table-borderless" W>
                        <thead>
                          <tr>
                            <th>Kode MK</th>
                            <th>Modul</th>
                            <th>Kelompok Modul</th>
                            <th>SKS</th>
                            <th>Total Peserta</th>
                            <th>Aksi</th>
                          </tr>
                        </thead>
                        <tbody style={{ borderTop: "2px solid black" }}>
                          {item.courses.map((course, courseIndex) => (
                            <tr key={courseIndex}>
                              <td>{course.kode_mk}</td>
                              <td>{course.name}</td>
                              <td>
                                {course.courseGroups.length > 0
                                  ? course.courseGroups
                                      .map(
                                        (courseGroup, courseGroupIndex) =>
                                          courseGroup.group.name
                                      )
                                      .join(", ")
                                  : "-"}
                              </td>
                              <td className="text-center">{course.sks}</td>
                              <td className="text-center">
                                {course.courseTotalParticipants.length > 0 ? course.courseTotalParticipants[0].total_participants : 0}
                              </td>
                              <td>
                                <Link
                                  to={{
                                    pathname: `/akademik/course-lecturers/${course.id}`,
                                  }}
                                  state={{
                                    ...course,
                                    semester: item.semester,
                                  }}
                                  className="btn btn-info text-white btn-sm"
                                >
                                  <i className="fas fa-eye"></i>
                                </Link>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseLecturers;
